import { isPhone } from '@/util/util'

/**
 * 手机号输入长度：大陆 11 位；美版等国际场景放宽（含国家码、分机等）。
 */
export const PHONE_INPUT_MAX_LENGTH_CN = 11
export const PHONE_INPUT_MAX_LENGTH_INTL = 20
/** 非 zh-CN：允许不含国家/区号时的较短本地号（如 7～9 位），上限仍与 maxLength 一致 */
export const PHONE_INPUT_MIN_LENGTH_INTL = 7

export function getPhoneInputMaxLength(locale) {
  return locale === 'zh-CN' ? PHONE_INPUT_MAX_LENGTH_CN : PHONE_INPUT_MAX_LENGTH_INTL
}

/**
 * 仅校验数字串（可先 strip 非数字）。
 * - zh-CN：大陆 11 位手机号（isPhone）
 * - 其它语言：7～20 位（含 9 位等本地/国际号；此前 10 位下限易误伤「未含区号」的合规则输入）
 */
export function isValidPhoneDigitsForLocale(digits, locale) {
  const d = String(digits == null ? '' : digits).replace(/\D/g, '')
  if (!d) return false
  if (locale === 'zh-CN') {
    return isPhone(d)
  }
  return d.length >= PHONE_INPUT_MIN_LENGTH_INTL && d.length <= PHONE_INPUT_MAX_LENGTH_INTL
}
